(function($){

  // Random featured image in product
  $(document).ready(function() {
    $( '.product-featured' ).each(function() {

        $holder    = $(window);
        $object    = $(this);
        $holderWidth  = $holder.width();
        $holderHeight = $holder.height();
        // $objectWidth  = $object.width() / 2 ;
        // $objectHeight = $object.height() / 2 ;
        $objectWidth  = $object.width();
        $objectHeight = $object.height();

           $(this).css({
                'left': Math.floor( Math.random() * Number( $holderWidth - $objectWidth )  ),
                'top' : Math.floor( Math.random() * Number( $holderHeight - $objectHeight )  )
           });
         })
  });

  // Home behaviour
  $(document).ready(function() {


    // media query event handler
      if (matchMedia) {
      const mq = window.matchMedia("(min-width: 769px)");
      mq.addListener(WidthChange);
      WidthChange(mq);
      }

      // media query change
      function WidthChange(mq) {
      if (mq.matches) {
        createHome();
      } else {

      }

      }


  });

  function createHome() {

    createHome = null;

    // Split home in rows
    var items = $(".home > div");
    for(var i = 0; i < items.length; i+=3) {
      items.slice(i, i+3).wrapAll("<div class='home-row'></div>");
    }


        // Randomise position of white space
        $(".home-row").each(function() {

          var children = $(this).children();
          var position = Math.floor(Math.random() * (children.length + 1));
          if (position == children.length)
            children.eq(position-1).after('<div class="empty"></div>');
          else
            children.eq(position).before('<div class="empty"></div>');

          });

        // Add random displacement
        $(".home-row").each(function() {
          var random = Math.floor(Math.random() * 1000);
          var $li = $(this).find('.home-product');
          $li.eq(random % $li.length).addClass("displaced");
        });

        return 1;

  }


  // Mobile menu
  $(document).ready( function() {
    $('.site-header-mobile_trigger').on("click", function() {
      $('.mobile-menu').toggleClass('is-open');
      $(this).text($(this).text() == 'Close' ? 'Menu' : 'Close');
      $('body').toggleClass('locked');

      return false
    })

    $('.filter-mobile').on("click", function() {
      $('.mobile-menu').removeClass('is-open');
      $('.overlay').hide();
      $('.site-header-mobile_trigger').text('Menu');
      $('body').removeClass('locked');
    })

    $('.site-header-mobile a[href="#about"]').click(function() {
      $('.about').show();
      $('.mobile-menu').removeClass('is-open');
      $('.site-header-mobile_trigger').text('Menu');
      $('body').addClass('locked');

          return false
    });

    $('.site-header-mobile a[href="#stocklist"]').click(function() {
      $('.stocklist').show();
      $('.mobile-menu').removeClass('is-open');
      $('.site-header-mobile_trigger').text('Menu');
      $('body').addClass('locked');

          return false
    });

    $('.site-header-mobile a[href="#faq"]').click(function() {
      $('.faq').show();
      $('.mobile-menu').removeClass('is-open');
      $('.site-header-mobile_trigger').text('Menu');
      $('body').addClass('locked');

          return false
    });

    $('.site-header-mobile a[href="#contact"]').click(function() {
      $('.contact').show();
      $('.mobile-menu').removeClass('is-open');
      $('.site-header-mobile_trigger').text('Menu');
      $('body').addClass('locked');

          return false
    });

  });


    // Filtering home
    $(document).ready( function() {

      if ($(window).width() > 768) {

      function getHashFilter() {
        var hash = location.hash;
        // get filter=filterName
        var matches = location.hash.match(/=([^&]+)/i);
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent(hashFilter);
      }


            $.fn.hideReveal = function(options) {
       options = $.extend({
         filter: '*',
         hiddenStyle: {
           opacity: 0.1,
         },
         visibleStyle: {
           opacity: 1
         },
       }, options);
       this.each(function() {
         var $items = $('.home-product');
         var $visible = $items.filter(options.filter);
         var $hidden = $items.not(options.filter);
         // reveal visible
         $visible.animate(options.visibleStyle);
         $visible.css('pointer-events', 'auto');
         // hide hidden
         $hidden.animate(options.hiddenStyle);
         $hidden.css('pointer-events', 'none');
       });
      };

      $(function() {

       var $container = $('.home');

       // bind filter button click
       $('.filter').on('click', function() {
         // var filterValue = $(this).attr('data-filter');
         // use filterFn if matches value
             var filterValue = $(this).attr('data-filter');
             // set filter in hash
             location = '/#=' + encodeURIComponent(filterValue);

             $container.hideReveal({
               filter: filterValue
             });

       });


         function onHashchange() {
           var filterValue = getHashFilter();
           if (!filterValue && isIsotopeInit) {
             $container.hideReveal({
               filter: filterValue
             });
           }
           // filter isotope
           $container.hideReveal({
             filter: filterValue
           });

        // set selected class on button
        $('.site-header').find('.active').removeClass('active');
        $('.site-header').find('[data-filter="' + filterValue + '"]').addClass('active');

         }

          onHashchange();

      });

      // filter items on button click
      $('.filter').on( 'click', function() {
        $('.filter').removeClass('active');
       $(this).addClass('active');
     });


    }

    else {

      function getHashFilter() {
  var hash = location.hash;
  // get filter=filterName
  var matches = location.hash.match(/=([^&]+)/i);
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent( hashFilter );
}

$( function() {

  var $grid = $('.home');

  // Fix overlap images
  $grid.imagesLoaded(function() {


  // bind filter button click
  $('.filter-mobile').on( 'click', function() {
    var filterAttr = $( this ).attr('data-filter');
    // set filter in hash
    location = '/#=' + encodeURIComponent(filterAttr);  });

  var isIsotopeInit = false;

  function onHashchange() {
    var hashFilter = getHashFilter();
    if ( !hashFilter && isIsotopeInit ) {
      return;
    }
    isIsotopeInit = true;
    // filter isotope
    $grid.isotope({
      itemSelector: '.home-product',
      filter: hashFilter,
      // disable scale transform transition when hiding
      hiddenStyle: {
        opacity: 0
      },
      visibleStyle: {
        opacity: 1
      }
    });
    // set selected class on button
    if ( hashFilter ) {
      $filters.find('.active').removeClass('active');
      $filters.find('[data-filter="' + hashFilter + '"]').addClass('active');
    }
  }

  $(window).on( 'hashchange', onHashchange );
  // trigger event handler to init Isotope
  onHashchange();
});

  });

    }

});

// function getHashFilter() {
//   var hash = location.hash;
//   // get filter=filterName
//   var matches = location.hash.match(/filter=([^&]+)/i);
//   var hashFilter = matches && matches[1];
//   return hashFilter && decodeURIComponent(hashFilter);
// }
// $(function() {
//
//   var $grid = $('.home');
//
//   // bind filter button click
//   var $filters = $('.filter').on('click', function() {
//     var filterAttr = $(this).attr('data-filter');
//     // set filter in hash
//     location = '/#filter=' + encodeURIComponent(filterAttr);
//   });
//
//   var isIsotopeInit = false;
//
//   function onHashchange() {
//     var hashFilter = getHashFilter();
//     if (!hashFilter && isIsotopeInit) {
//       return;
//     }
//     isIsotopeInit = true;
//     // filter isotope
//     $grid.isotope({
//       itemSelector: '.home-product',
//       filter: hashFilter
//     });
//
//     // set selected class on button
//     if (hashFilter) {
//       $filters.find('.active').removeClass('active');
//       $filters.find('[data-filter="' + hashFilter + '"]').addClass('active');
//     }
//   }
//
//   $(window).on('hashchange', onHashchange);
//   // trigger event handler to init Isotope
//   onHashchange();
// });

  // Commissions
  $(document).ready( function() {

  if($(window).width() > 768) {
    var items = $(".commissions-image");
    for(var i = 0; i < items.length; i+=4) {
      items.slice(i, i+4).wrapAll("<div class='commissions-row'></div>");
    }

  }

    // Count items commission
    $(document).ready( function() {

          function convertToRoman(num) {
          var roman = {
            M: 1000,
            CM: 900,
            D: 500,
            CD: 400,
            C: 100,
            XC: 90,
            L: 50,
            XL: 40,
            X: 10,
            IX: 9,
            V: 5,
            IV: 4,
            I: 1
          };
          var str = '';

          for (var i of Object.keys(roman)) {
            var q = Math.floor(num / roman[i]);
            num -= q * roman[i];
            str += i.repeat(q);
          }

          return str;

        }

        $('.counter-number').each(function(i) {
            $(this).text(convertToRoman(++i))
          });

      });

  });


  // Remove fake footer
  $(window).scroll(function() {
      if ($(this).scrollTop() > $(document).height() - $(window).height() - 300) {
          $('.fake-footer').fadeOut();
      } else {
          $('.fake-footer').fadeIn();
      }
  });

  // Remove lightbox mobile
  $(function() {
    if ($(window).width() < 768) {
      $('.product-gallery a').on("click", function() {
        return false
      })
    };
    // if ($(window).width() < 768) {
    //   $('.product-gallery a').removeAttr('data-featherlight');
    // };
  })

  // Lightbox for featured image
  $(document).ready(function() {
    $.extend($.featherlight.defaults, {
      openSpeed:   0,
	    closeSpeed:  0,
      closeOnClick:   'anywhere',
      afterContent: function() {
        // Add a div for the legend if needed:
        this.$legend = this.$legend || $('<div class="commissions-caption"/>').insertAfter(this.$content);
        // Set the content:
        this.$legend.text(this.$currentTarget.attr('alt'));
}
    });
  });

  // About overlay
  $(document).ready(function() {
    $('a[href="#about"]').click(function() {
      $('.about').show();
      $('.overlay:not(.overlay.about)').hide();
      $('body').addClass('locked');

          return false
    });

    $('.about').click(function() {
      $('.overlay').hide();
      $('body').removeClass('locked');
    });

  });

  // Stocklist overlay
  $(document).ready(function() {
    $('a[href="#stocklist"]').click(function() {
      $('.stocklist').show();
      $('.overlay:not(.overlay.stocklist)').hide();
      $('body').addClass('locked');

          return false

    });

    $('.stocklist').click(function() {
      $('.overlay').hide();
      $('body').removeClass('locked');
    });

  });

  // FAQ overlay
  $(document).ready(function() {
    $('a[href="#faq"]').click(function() {
      $('.faq').show();
      $('.overlay:not(.overlay.faq)').hide();
      $('body').addClass('locked');

          return false

    });

    $('.faq').click(function() {
      $('.overlay').hide();
      $('body').removeClass('locked');
    });

  });

  // Contact overlay
  $(document).ready(function() {
    $('a[href="#contact"]').click(function() {
      $('.contact').show();
      $('.overlay:not(.overlay.contact)').hide();
      $('body').addClass('locked');

          return false

    });

    $('.contact').click(function() {
      $('.overlay').hide();
      $('body').removeClass('locked');
    });

  });

  // Product cart quantity
jQuery(document).ready(function(){

    // This button will increment the value
    $('.cart-section .qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[id='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
        $( "#update" ).trigger( "click" );

    });
    // This button will decrement the value till 0
    $(".cart-section .qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[id='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
        $( "#update" ).trigger( "click" );

    });
});

jQuery(document).ready(function(){
    // This button will increment the value
    $('.cart-section .button-plus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(".cart-section .button-minus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
});

// Re-type password
  // $(function(){
  //   $('#create_customer').submit(function(e) {
  //     if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
  //       e.preventDefault();
  //       alert('Passwords do not match.');
  //     }
  //   });
  // });


})(jQuery);
